import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import InPageHeaderAltNav from "../../components/media/InPageHeaderAltNav";
import PageTitles from "../../components/text/PageTitles";
import ArticleText from "../../components/text/ArticleText";
import ImgTextCard from "../../components/media/ImgTextCard";
import Footer from "../../components/Footer";
import bgInternalImage from "../../images/accrp-historical-marker.jpg";
import bhtMap from "../../images/bht_map_horizontal_c.png";
import sitePlaceholder from "../../images/ccmcc.jpg";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import { heritageSitesContext } from "../../contexts/HeritageSitesContext";
import { Skeleton } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Stack from "@mui/material/Stack";

const BlackHeritage = () => {
  const [sitesData, setSitesData] = useState([]);
  const [newData, setNewData] = useState("All Locations");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [offset, setOffset] = useState(0);
  const { heritageSites, loading } = useContext(heritageSitesContext);
  const [isSitesDataLoading, setIsSitesDataLoading] = useState(true);

  const handleFilterSection = (filterOption) => {
    setNewData(filterOption);
    handlePageClick(0);
  };

  const blackHeritageSkeletonTiles = Array.from({ length: 4 }).map(
    (_, index) => (
      <Col
        key={index}
        lg={3}
        md={4}
        sm={6}
        style={{
          paddingRight: "calc(var(--bs-gutter-x) * 0.5)",
          paddingLeft: "calc(var(--bs-gutter-x) * 0.5)",
          marginBottom: "2rem",
        }}
      >
        <div
          style={{
            height: "16rem",
            borderRadius: "10px",
            background: `linear-gradient(
                      rgba(224, 224, 224, 0.32),
                      rgba(189, 189, 189, 0.61),
                      rgba(158, 158, 158, 0.95)
                      )`,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            overflow: "hidden",
            paddingBottom: "0",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Skeleton
              variant="rectangle"
              animation="wave"
              height={130}
              width="80%"
              style={{ marginBottom: 6 }}
            />
          </div>
          <div
            style={{
              padding: "0.75rem 1rem",
            }}
          >
            <Skeleton
              variant="text"
              animation="wave"
              height={24}
              width="80%"
              style={{ marginBottom: 6 }}
            />
            <Skeleton variant="text" animation="wave" height={18} width="60%" />
          </div>
        </div>
      </Col>
    ),
  );

  const getHeritageSites = () => {
    const data = heritageSites;
    let tylerArr = data;
    let filteredItems = [data];

    // console.log(filteredItems);

    switch (newData) {
      case "NewberryJonesville":
        filteredItems = tylerArr.filter(
          (item) => item.SiteGroupName === "NewberryJonesville",
        );
        break;
      case "Archer":
        filteredItems = tylerArr.filter(
          (item) => item.SiteGroupName === "Archer",
        );
        break;
      case "Gainesville":
        filteredItems = tylerArr.filter(
          (item) => item.SiteGroupName === "Gainesville",
        );
        break;
      case "HighSprings":
        filteredItems = tylerArr.filter(
          (item) => item.SiteGroupName === "High Springs",
        );
        break;
      case "MicanopyWacahoota":
        filteredItems = tylerArr.filter(
          (item) => item.SiteGroupName === "MicanopyWacahoota",
        );
        break;
      case "MonteochaGordonLaCrosse":
        filteredItems = tylerArr.filter(
          (item) => item.SiteGroupName === "MonteochaGordonLaCrosse",
        );
        break;
      case "Pleasant Street5th Ave Historic":
        filteredItems = tylerArr.filter(
          (item) => item.SiteGroupName === "Pleasant Street5th Ave Historic",
        );
        break;
      case "WaldoHawthorneCampvilleRochelle":
        filteredItems = tylerArr.filter(
          (item) => item.SiteGroupName === "WaldoHawthorneCampvilleRochelle",
        );
        break;
      case "Alachua Newnansville":
        filteredItems = tylerArr.filter(
          (item) => item.SiteGroupName === "AlachuaNewnansville",
        );
        break;
      default:
        // Render all items by default
        filteredItems = tylerArr;
        // console.log(filteredItems);
        // console.log(filteredItems.SiteGroupName);
        break;
    }

    const sliced = filteredItems.slice(offset, offset + perPage);
    const sitesData = sliced.map((site) => (
      <Col
        display="flex"
        style={{
          paddingRight: "calc(var(--bs-gutter-x)* .5)",
          paddingLeft: "calc(var(--bs-gutter-x)* .5",
        }}
        gridGap={"3%"}
        lg={3}
        md={4}
        sm={6}
        key={site.MondayID}
      >
        <Link
          className="hoverState"
          to={{
            pathname: `/black-heritage-trail/${site.MondayID}`,
            state: filteredItems,
          }}
        >
          <ImgTextCard
            siteImg={
              site.ImageList && site.ImageList.length > 0
                ? `${process.env.PUBLIC_URL}${encodeURI(
                    site.ImageList[0].relativePath,
                  )}`
                : sitePlaceholder
            }
            siteName={`${
              site.SiteName.length > 30
                ? site.SiteName.replace(/^(.{30}[^\s]*).*/, "$1")
                : site.SiteName
            }`}
            siteAddress={`${
              site.Address.length > 40
                ? site.Address.replace(/^(.{40}[^\s]*).*/, "$1")
                : site.Address
            }`}
          />
        </Link>
      </Col>
    ));

    setSitesData(sitesData);
    setIsSitesDataLoading(false);
    // console.log("SitesData1", sitesData);
    setPageCount(Math.ceil(filteredItems.length / perPage));
  };

  const handlePageClick = (selectedPage) => {
    const offset = selectedPage * perPage;
    setCurrentPage(selectedPage);
    setOffset(offset);
  };

  useEffect(() => {
    // console.log("Use Effect ");
    // console.log(heritageSites);
    // console.log(currentPage);
    // console.log("SitesData", sitesData);
    if (heritageSites) {
      getHeritageSites();
    }
  }, [newData, offset, perPage, currentPage, heritageSites]);

  return (
    <main className="blackHeritageFilter">
      <InPageHeaderAltNav inPageBGImage={bgInternalImage} />
      <PageTitles pageTitleFirst={"Digital Black Heritage Trail"} />
      <ArticleText
        articleText={`The Alachua County Digital Black Heritage Trail map and website aim to resist the systematic, century-long erasure and forced removal of Black life in Alachua County. Demonstrative of the resilience and resistance of Black place-making and institution-building, this map reflects the intergenerational memories of Black belonging in Alachua County. To quote Walter Hood and Grace Mitchell Tada, “Black Landscapes Matter.”`}
      />
      <ArticleText
        articleText={`As a counter-archive of Black cultural memory, this project contributes to both county and nationwide efforts of truth and reconciliation. Only by telling the truth about our shared past can we collectively begin to heal. This project is both a reparative oﬀering and a call to action to build a more just future.`}
      />

      <div className="articleText">
        <Container>
          <Row>
            <Col className="hold-article">
              <p className="articleText">
                The creation of the Alachua County Digital Black Heritage Trail
                would not have been possible without the contributions of the
                ACCRP, its subcommittees, Temple Shir Shalom, local historians
                Dr. Sherry Sherrod DuPree, Garlenda Greene Grant, UNESCO-TST,
                Ms. Lizzie Jenkins, Karen Kirkman, Janis Owens, and the UF
                Museum Studies Program. We are also grateful for our community
                partners in the cultural heritage sector who contributed their
                time and expertise to this project: The A. Quinn Jones Museum &
                Cultural Center, Cotton Club Museum & Cultural Center, Real
                Rosewood Foundation, Historic Haile Homestead at Kanapaha
                Plantation, Matheson History Museum, Cultural Arts Coalition,
                Pleasant Street Historic Society, Samuel Proctor Oral History
                Program, Visit Gainesville and Alachua County. Additional
                acknowledgment is owed to the State Archives of Florida for the
                use of their archival and library resources available at{" "}
                <a className="hyperlinks" href="https://www.floridamemory.com/">
                  FloridaMemory.com
                </a>
                , as well as the historical marker database records from the
                Florida Division of Historical Resources.
              </p>
              <p className="articleText">
                To add a place of significance to the Digital Black Heritage
                Trail, please use the Contact form located on our &nbsp;
                <a className="hyperlinks" href="/get-involved">
                  "Get Involved"
                </a>{" "}
                page to send us an email.{" "}
              </p>
              <p className="articleText">
                For a downloadable PDF version of the Digital Black Heritage
                Trail Map, please click here: &nbsp;
                <a
                  className="hyperlinks"
                  rel="noreferrer"
                  target="_blank"
                  href="/files/bht_map_vertical_C_ada.pdf"
                >
                  "Black Heritage Trail Map"
                </a>
                .
              </p>
            </Col>
          </Row>
          {/* Article text content */}
        </Container>
      </div>
      <div className="holdBHTMap">
        <img
          src={bhtMap}
          alt="Digital Black Heritage Trail Map"
          className="bht-map-image"
        />
      </div>
      <div className="siteContainerHolder">
        <Container className="holdSites">
          <Row
            style={{
              padding: "0 0 2% 0",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Col
              className="filtering-buttons"
              xs={12}
              lg={4}
              style={{ fontFamily: "Source Sans Pro", display: "flex" }}
            >
              <Button
                style={{
                  backgroundColor: "#E6C200",
                  color: "black",
                  borderColor: "black",
                  margin: "0% 2% 0% 2%",
                }}
                onClick={() => handleFilterSection("All Locations")}
              >
                Show All
              </Button>

              <Dropdown>
                <Dropdown.Toggle
                  style={{
                    backgroundColor: "#E6C200",
                    color: "black",
                    borderColor: "black",
                  }}
                  id="dropdown-basic"
                >
                  Filter Locations
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => handleFilterSection("Alachua Newnansville")}
                    href="#/action-3"
                  >
                    Alachua/Newnansville
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterSection("Archer")}
                    href="#/action-2"
                  >
                    Archer
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterSection("Gainesville")}
                    href="#/action-2"
                  >
                    Gainesville
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterSection("HighSprings")}
                    href="#/action-2"
                  >
                    High Springs
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterSection("MicanopyWacahoota")}
                    href="#/action-2"
                  >
                    Micanopy/Wacahoota
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() =>
                      handleFilterSection("MonteochaGordonLaCrosse")
                    }
                    href="#/action-2"
                  >
                    Monteocha/Gordon/LaCrosse
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => handleFilterSection("NewberryJonesville")}
                    href="#/action-1"
                  >
                    Newberry/Jonesville
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() =>
                      handleFilterSection("Pleasant Street5th Ave Historic")
                    }
                    href="#/action-1"
                  >
                    Pleasant Street5th Ave Historic
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() =>
                      handleFilterSection("WaldoHawthorneCampvilleRochelle")
                    }
                    href="#/action-1"
                  >
                    Waldo/Hawthorne/Campville/Rochelle
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>

            <Col className="filtering-tagline" xs={12} lg={8}>
              <h4 style={{ color: "white" }}>
                You are currently viewing:{" "}
                <span style={{ color: "yellow", textDecoration: "underline" }}>
                  {newData}
                </span>
              </h4>
            </Col>
          </Row>
          <Row>
            <Row>
              {isSitesDataLoading ? blackHeritageSkeletonTiles : sitesData}
              {/* {!sitesData && <p style={{ color: "#FFFFFF" }}> Loading...</p>}
              {sitesData} */}
              {/*  <ReactPaginate
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(e) => handlePageClick(e.selected)}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                forcePage={currentPage}
              /> */}
              {/* <nav aria-label="Pagination Navigation">
                <ReactPaginate
                  previousLabel={"Prev"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handlePageClick(e.selected)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={currentPage}
                />
              </nav> */}

              <Stack spacing={2} alignItems="center">
                <Pagination
                  count={pageCount}
                  page={currentPage + 1}
                  onChange={(event, value) => handlePageClick(value - 1)}
                  siblingCount={2}
                  boundaryCount={2}
                  shape="rounded"
                  variant="outlined"
                  sx={{
                    "& .MuiPaginationItem-root": {
                      backgroundColor: "#455E4A",
                      color: "white",
                      minWidth: "40px",
                      height: "40px",
                      borderColor: "white",
                    },
                    "& .MuiPaginationItem-root:hover": {
                      backgroundColor: "#e6c200",
                      color: "black",
                    },
                    "& .Mui-selected, & .Mui-selected:hover": {
                      backgroundColor: "#ffffff !important",
                      color: "black",
                    },
                  }}
                  // sx={{
                  //   "& .MuiPaginationItem-root": {
                  //     backgroundColor: "#455E4A",
                  //     color: "white",
                  //     minWidth: "40px",
                  //     height: "40px",
                  //     borderColor: "white",
                  //   },
                  //   "& .MuiPaginationItem-root:hover": {
                  //     backgroundColor: "#223a27",
                  //     color: "white",
                  //   },
                  //   "& .Mui-selected, & .Mui-selected:hover": {
                  //     backgroundColor: "#e6c200 !important",
                  //     color: "black",
                  //   },
                  // }}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{
                        previous: ArrowBackIcon,
                        next: ArrowForwardIcon,
                      }}
                      {...item}
                    />
                  )}
                />
              </Stack>
            </Row>
          </Row>
        </Container>
      </div>
      <Footer />
    </main>
  );
};

export default BlackHeritage;
